// @ts-nocheck
/* eslint-disable */
export const appSuccess48Icon = {
    data: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" rx="24" fill="currentColor"/><path d="M17.8444 27.6185L21.7561 30.3209C22.2105 30.6349 22.8333 30.521 23.1472 30.0666L29.6238 20.692" stroke="#FAFBFB" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'success-48' as const
};